<template>
  <RouterLink class="app-profile-my-itineraries-item" :to="routeTo">
    <div class="image-wrapper">
      <div class="image" :style="{ backgroundImage }" />
    </div>

    <div class="title">{{ itinerary.title }}</div>

    <div v-if="startDate" class="d-flex">
      <div v-if="startDate" class="small-grey">{{ startDate }}</div>
      <div v-if="endDate && startDate !== endDate" class="small-grey ml-1">- {{ endDate }}</div>
    </div>

    <div v-if="itinerary.destination" class="d-flex">
      <div class="small-grey">{{ itinerary.destination.title }},</div>
      <div v-if="itinerary.destination.country" class="small-grey ml-1">{{ itinerary.destination.country }}</div>
    </div>
  </RouterLink>
</template>

<script>
import { getEntityRoute } from '@/helpers/entityType';
import { formatDate } from '@/helpers/dateTimeHelper';

export default {
  name: 'ProfileMyItinerariesItem',
  props: {
    itinerary: {
      type: Object,
      required: true,
    },
  },
  computed: {
    backgroundImage() {
      return this.itinerary.media?.url ? `url(${this.itinerary.media.url})` : 'none';
    },
    routeTo() {
      return getEntityRoute(this.itinerary);
    },
    startDate() {
      return formatDate(this.itinerary.startDate);
    },
    endDate() {
      return formatDate(this.itinerary.endDate);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-profile-my-itineraries-item {
  display: flex;
  flex-direction: column;
  gap: 6px;

  .image-wrapper {
    width: 100%;
    height: 250px;
    overflow: hidden;
    margin-bottom: 8px;

    .image {
      display: block;
      width: 100%;
      height: 100%;
      background-color: vars.$c-gray-d8;
      background-size: cover;
      background-position: center;
      transition: all 0.3s linear;
    }

    &:hover {
      .image {
        transform: scale(0.95);
      }
    }
  }

  .title {
    color: vars.$c-dark-gray;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 1px;
    line-height: 34px;
    text-transform: uppercase;
  }
}
</style>
